import './Name.scss';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Button from '../../common/Button/Button';
import Text from '../../common/Text/Text';
import { ChangeEvent } from 'react';
import Input from '../../common/Input/Input';
import useBooking from '../../hooks/useBooking/useBooking';
import { useNavigate } from 'react-router';

const Name = () => {
  const { name, setName } = useBooking();
  const navigate = useNavigate();

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value.replace(/[^a-zA-ZÀ-ɏ\s'.,-]/g, ''));
  };

  const handleContinue = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigate('/phone-number');
  };

  return (
    <div className="name">
      <img src={logo} className="logo" />
      <div className="content">
        <Text type="header">What&apos;s your name?</Text>
        <Input inputId="name" onChange={handleNameChange} value={name} maxLength={255} />
        <Button
          buttonStyleType="primary"
          label="Continue"
          handleClick={handleContinue}
          customStyling={{ width: '100%' }}
          disabled={!name.trim()}
        />
      </div>
    </div>
  );
};

export default Name;
